import { render, staticRenderFns } from "./OfficerDetailsModal.vue?vue&type=template&id=2da7038a&scoped=true"
import script from "./OfficerDetailsModal.vue?vue&type=script&lang=js"
export * from "./OfficerDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./OfficerDetailsModal.vue?vue&type=style&index=0&id=2da7038a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da7038a",
  null
  
)

export default component.exports